import {
  CheckSquareOutlined,
  CloseSquareOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Input, Table } from "antd";
import "antd/dist/antd.css";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import {
  itemRender,
  onShowSizeChange,
} from "../../../../../paginationfunction";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../../StoreComponents/hooks/useStoreLog";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const ProfileCategoryList = () => {
  const { empId } = useParams();

  const [showTable, setShowTable] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [tableIndex, setTableIndex] = useState();

  const {
    data: dataSource1,
    error: error1,
    mutate: mutate1,
  } = useSWR(empId ? `hr/employee/${empId}` : null, fetcher);

  const handleUpdateAccess = (productId, categoryId) => {
    console.log(productId);
    API.post("store/permission/users", {
      empid: parseInt(empId),
      proid: parseInt(productId),
    }).then((res) => {
      console.log(res);
      if (!res.data.error) {
        PostStoreLog(1, "Permission store product");
        handleOpenData(categoryId, tableIndex);
      }
    });
  };
  const handleDeleteAccess = (productId, categoryId) => {
    API.delete("store/permission/users", {
      headers: { empid: parseInt(empId), proid: parseInt(productId) },
    }).then((res) => {
      if (!res.data.error) {
        PostStoreLog(3, "Delete permission store product ");
        handleOpenData(categoryId, tableIndex);
      }
    });
  };
  const {
    data: categoryBox,
    error: error4,
    mutate: mutate3,
  } = useSWR(`store/products/manageproducts`, fetcher);

  const handleOpenData = (catId, index) => {
    setTableIndex(index);
    setShowTable({});
    API.get(`store/permission/users/${empId}/${catId}`).then((res) => {
      if (res.data.data) {
        setDataSource(res.data.data);
        setShowTable({ status: "true", id: index });
      }
    });
  };

  const columns = [
    {
      title: " ID",
      className: "dark_bg ",
      dataIndex: "PROID",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type employee id here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        return record.PROID == value;
      },
    },
    {
      title: "Product Name",
      className: "dark_bg ",
      dataIndex: "PRONAME",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type name here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        return record.PRONAME.toLowerCase().includes(value.toLowerCase());
      },
    },

    {
      title: "Update",
      className: "dark_bg ",
      render: (text, record) => (
        <div className="text-center">
          {record.STATUS === 0 && (
            <Button
              style={{
                backgroundColor: "#3C8DBC",
                color: "#fff",
              }}
              onClick={() => {
                handleUpdateAccess(record.PROID, record.PROCATE);
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Access Product"
              shape="circle"
              icon={<CheckSquareOutlined />}
            />
          )}
          {record.STATUS === 1 && (
            <Button
              style={{
                backgroundColor: "#F55050",
                color: "#fff",
              }}
              onClick={() => {
                handleDeleteAccess(record.PROID, record.PROCATE);
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Access Product"
              shape="circle"
              icon={<CloseSquareOutlined />}
            />
          )}
        </div>
      ),
    },
  ];

  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Profile - BBA Store</title>
        <meta name="description" content="Profile - BBA Store" />
      </Helmet>
      <div className="page-wrapper">
        {!dataSource && !dataSource1 ? (
          <NotFoundPage></NotFoundPage>
        ) : (
          <div className="content container-fluid main-container">
            <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
              <h3 className="text-start text-dark">
                Not Allow Product To {dataSource1?.NAME_ENGLISH} (
                {dataSource1?.DESIGNATION}, {dataSource1?.DEPARTEMENT})
              </h3>
              <div>
                <Link to={`/systemaccess/userprofile/${empId}`}>
                  <button type="button" className="btn btn-color_store px-3">
                    <i className="fa fa-eye"></i>
                    <span>View Not Allowed Products</span>
                  </button>
                </Link>
                <button
                  onClick={() => navigate(-1)}
                  class="btn btn-o px-3 ms-1"
                  style={{
                    background: "#000",
                    color: "#fff",
                    borderRadius: "10px",
                  }}
                >
                  <i class="fa fa-hand-o-left"></i> Back
                </button>
              </div>
            </div>

            {/* Product By Category */}
            <div className="my-4 ">
              <div className="row m-0">
                {categoryBox
                  ? categoryBox.categories.map((item, index) => (
                      <div className="col-12 col-md-12 my-2 col-lg-12 ">
                        <div
                          className="d-flex  align-items-center "
                          onClick={() => handleOpenData(item.CAT_ID, index)}
                          style={{
                            boxShadow:
                              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                        >
                          <div className="px-5 py-4 tableColor  rounded-start  ">
                            <i className="fa fa-gift text-white fs-1 mt-2"></i>
                          </div>
                          <div className="ms-3 lh-1">
                            <h4
                              className="lh-1  pt-1 fs-5"
                              style={{
                                fontFamily:
                                  "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "600",
                              }}
                            >
                              {item.CATEGORYEN
                                ? item.CATEGORYEN.toUpperCase()
                                : ""}
                              <i class="la la-hand-o-down ms-1"></i>
                            </h4>
                            <h5 className="lh-1 fw-normal text-start">
                              {item.CATEGORYBN ? item.CATEGORYBN : ""}
                            </h5>
                            <p
                              className="text-start fs-5 "
                              style={{ fontWeight: "600" }}
                            >
                              <a href="#">{item.PRODUCTS}</a>
                            </p>
                          </div>
                        </div>
                        {showTable.status === "true" &&
                          showTable.id === index && (
                            <div className="row  m-0">
                              <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                  <Table
                                    className="table-striped"
                                    pagination={{
                                      total:
                                        dataSource === undefined
                                          ? 0
                                          : dataSource.length,
                                      showTotal: (total, range) =>
                                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                      showSizeChanger: true,
                                      onShowSizeChange: onShowSizeChange,
                                      itemRender: itemRender,
                                    }}
                                    style={{ overflowX: "auto" }}
                                    columns={columns}
                                    // bordered
                                    dataSource={
                                      dataSource === undefined ? [] : dataSource
                                    }
                                    rowKey={(record) => record.CAT_ID}
                                    onChange={console.log("change")}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProfileCategoryList;
